/**
 * Handing an admin into Remote Support from the asset register.
 *
 * The register is a web page; the screen session runs through the admin's own
 * iBoon Agent, where Remote by iBoon lives. So "Remote support" does not open
 * a session here -- it opens the Agent, on the admin's machine, at the chosen
 * employee, where the existing request -> popup -> approve -> screen flow
 * takes over (see iboon-agent's deep_link.rs and the Devices page there). The
 * employee still gets the same approval prompt; nothing is seen until they
 * allow it.
 *
 * The link carries the mesh device id and the owner's email -- the Agent
 * matches a tile on either -- and nothing else: it selects a machine, it does
 * not start anything.
 */

const SCHEME = 'iboon-agent';

export function remoteSupportUrl(deviceId: string, email: string | null): string {
  const params = new URLSearchParams({ device: deviceId });
  if (email) params.set('email', email);
  return `${SCHEME}://remote-support?${params.toString()}`;
}

/**
 * Opens the scheme URL. Assigning location.href is what makes the browser
 * show its "Open iBoon Agent?" prompt for a custom scheme; window.open is
 * commonly blocked for these.
 */
export function openRemoteSupport(deviceId: string, email: string | null): void {
  window.location.href = remoteSupportUrl(deviceId, email);
}
